///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';

import { PasswordResetInitService } from './password-reset-init.service';
import { SuiUserDTO } from '../../../generated/shared-sui-types.model';
import { UserDTO } from '../../../generated/shared-types.model';

@Component({
    selector: 'winde-password-reset-init',
    templateUrl: './password-reset-init.component.html',
    styleUrls: ['./password-reset-init.component.scss'],
    standalone: false
})
export class PasswordResetInitComponent {
    public user = new SuiUserDTO({} as UserDTO);
    public success: string;

    constructor(private readonly passwordResetInitService: PasswordResetInitService) {
        this.user.login.isMandatory = true;
    }

    public requestReset(): void {
        if (!this.user.login.validateAndShowError()) {
            return;
        }

        this.passwordResetInitService.save(this.user.login.value).subscribe({
            next: () => (this.success = 'OK'),
            error: () => (this.success = null)
        });
    }
}
